'use strict';

module.exports = 'year|month|week|day|hour|minute|second|millisecond';